'use strict';
import './component.scss';

// Adds 'selected' class to the last selected 'skip-link' link.
let skipLinks = document.getElementsByClassName("skip-link");

for (let i = 0; i < skipLinks.length; i++) {
    skipLinks[i].addEventListener("click", function () {
        let current = document.querySelectorAll(".selected.skip-link");
        if (current.length > 0) {
            current[0].className = current[0].className.replace(" selected", "");
        }
        this.className += " selected";
    });
};